import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            minWidth: '700px',
        },
        loadingContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            justifyContent: 'center',
            margin: theme.spacing(2, 0),
        },
    }
})

export default useStyles
